const cropView = (data) => {
  let formData = data && data.getCropById && data.getCropById.CropFormData;
  if (formData) {
    let view = {
      name: formData.new_profile_crop_profile_name,
      sections: [
        {
          name: "Crop or Commodity Information",
          fields: [
            {
              number: 1,
              label: "Crop ID",
              value: formData.new_profile_crop_crop_id,
            },
            {
              number: 2,
              label: "Work State",
              value: formData.new_profile_crop_crop_work_state,
            },
            {
              number: 3,
              label: "Crop or Agricultural Activity",
              value: formData.new_profile_crop_crop_agricultural_activity,
            },
            {
              number: 4,
              label: "Wage Offer",
              value: formData.new_profile_crop_wage_offer,
            },
            {
              number: 5,
              label: "Per",
              value: formData.new_profile_crop_per,
            },
            {
              number: 6,
              label: "Piece Rate Offer",
              value: formData.new_profile_crop_piece_rate_offer,
            },
            {
              number: 7,
              label:
                "Piece Rate Units / Estimated Hourly Rate / Special Pay Information",
              value: formData.new_profile_crop_piece_rate_units,
            },
          ],
        },
      ],
    };
    return view;
  }
};

export default cropView;
